<ng-container *ngIf="(isLoadingHomeItemDetail$ | async) === false; else placeholder">
  <ng-container *ngIf="homeItemDetail$ | async as detail">
    <div class="container">
      <div class="container-header">
        <app-home-item-header
          class="item-header"
          [isMobile]="isMobile$ | async"
          [homeItemDetail]="detail"
          [hasWidgets]="hasWidgets$ | async"
          (trackEvent)="trackEvent($event)">
        </app-home-item-header>
        <div class="container-header-desktop">
          <div class="content-search" *ngIf="(isMobile$ | async) === false as isNotMobile">
            <div class="content-title">
              <span class="circle-airline hidden" *ngIf="showLogo(detail.logo_url)">
                <app-image
                  [type]="typeImageFlight"
                  [src]="detail.logo_url"
                  [borderRadius]="30">
                </app-image>
              </span>
              <p class="title">
                {{detail.title}}
              </p>
              <p class="subtitle">
                {{detail.sub_title}}
              </p>
            </div>
            <app-home-item-search-desktop
              [landingDestination]="(isPlace$ | async)"
              [source]="pageCode"
              [widgets]="countryModulesCollection$ | async"
              [groupSearchTabs]="groupSearchTabs">
            </app-home-item-search-desktop>
          </div>
        </div>
      </div>
      <div class="content-card" [class.no-widgets]="(hasWidgets$ | async) === false">
        <div class="content">
          <div class="container-headers">
            <div class="content-title">
              <span class="circle-airline hidden" *ngIf="showLogo(detail.logo_url)">
                <app-image
                  [type]="typeImageFlight"
                  [src]="detail.logo_url"
                  [borderRadius]="30">
                </app-image>
              </span>
              <p class="title">
                {{detail.title}}
              </p>
              <p class="subtitle">
                {{detail.sub_title}}
              </p>
            </div>
            <ng-container *ngIf="isMobile$ | async as isMobile">
              <ng-container *ngIf="(widgets$ | async) as widgets">
                <div class="content-links" *ngIf="widgets.length > 0">
                  <ng-container *ngFor="let type of widgets; trackBy: trackByType">
                    <app-home-item-links
                      [isMobile]="isMobile"
                      [landingDestination]="isPlace$ | async"
                      [isLandingDestination]="true"
                      [type]="type"
                      [source]="pageCode"
                      [airlineCode]="detail.airline_code"
                      [destinationCode]="detail.destination_code"
                      (autosSearch)="autosSearch()">
                    </app-home-item-links>
                  </ng-container>
                </div>
              </ng-container>                
            </ng-container>
            <div class="content-search" *ngIf="(isMobile$ | async) === false">
              <div class="content-title">
                <span class="circle-airline hidden" *ngIf="showLogo(detail.logo_url)">
                  <app-image
                    [type]="typeImageFlight"
                    [src]="detail.logo_url"
                    [borderRadius]="30">
                  </app-image>
                </span>
                <p class="subtitle">
                  {{detail.sub_title}}
                </p>
                <p class="title">
                  {{detail.title}}
                </p>
              </div>
            </div>
          </div>
          <div class="content-sections">
            <div class="content-section">
              <app-home-section-list
                [isMobile]="isMobile$ | async"
                [departurePlace]="(departurePlace$ | async)"
                [arrivalPlace]="(placeArrival$ | async)"
                [salesChannel]="salesChannel$ | async"
                [source]="pageCode"
                [branchCode]="branchCode$ | async"
                [homeSections]="detail.sections"
                [pageCode]="detail.code"
                [airline]="detail.airline_code"
                [flightOffers]="flightOffers$ | async"
                [widgets]="widgets$ | async">
              </app-home-section-list>
            </div>
          </div>
          <div class="footer" #footerHTML [innerHTML]="footerDynamic|safeHtml"></div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #placeholder>
  <app-home-item-placeholder></app-home-item-placeholder>
</ng-template>

<div #modalWebView class="modal-webview">
  <app-swipe-up [height]="90" [showSwipeUp]="true" (toggleShowSwipeUp)="toggleShowSwipeUp()">
    <ng-container content>
      <div class="iframe">
        <a (click)="toggleShowSwipeUp()" class="close-button">
          <i aria-hidden="true" class="icon-close"></i>
        </a>
        @defer (when loadingIframe) {
          @if (loadingIframe) {
            <div class="loader">
              <app-travel-loader
                [domManipulateOff]="true">
              </app-travel-loader>
            </div>
          }
        } 
        <iframe #iframeWebView (load)="loadIframe()" title="Modal WebView"></iframe>
      </div>
    </ng-container>
  </app-swipe-up>
</div>
